// extracted by mini-css-extract-plugin
export default {"main":"AdminControllButtons_main__9TPM3","editBut":"AdminControllButtons_editBut__fojZC","delBut":"AdminControllButtons_delBut__lgwtx"};